export const LAUNCH_OWNERS = [
  { value: "Steven", label: "Steven" },
  { value: "Richard", label: "Richard" },
  { value: "Steven + Richard", label: "Steven + Richard" },
  { value: "Both", label: "Both" },
  { value: "External", label: "External" },
];

export const LAUNCH_WORKSTREAMS = ["Product", "Content", "Commercial", "Marketing", "Validation", "Launch"].map((w) => ({ value: w, label: w }));

export const WORKSTREAM_COLOR = {
  Product: "#1D4ED8", Content: "#0EA5A4", Commercial: "#E0A82E",
  Marketing: "#EC4899", Validation: "#8B5CF6", Launch: "#16A34A",
};

export const READINESS_WEIGHTS = [
  { value: "0", label: "0 — no readiness weight" },
  { value: "1", label: "1 — normal" },
  { value: "2", label: "2 — important" },
  { value: "3", label: "3 — critical to launch" },
];

export const LAUNCH_STATUS = [
  { value: "Not started", label: "Not started" },
  { value: "Planned", label: "Planned" },
  { value: "In progress", label: "In progress" },
  { value: "Blocked", label: "Blocked" },
  { value: "Ready for review", label: "Ready for review" },
  { value: "Complete", label: "Complete" },
];

export const LAUNCH_PRIORITY = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Critical", label: "Critical" },
];

export const LAUNCH_CATEGORIES = [
  "App development",
  "Content production",
  "User accounts",
  "Parent controls",
  "Payments and subscriptions",
  "Apple App Store",
  "Google Play Store",
  "Website and landing page",
  "Legal and privacy",
  "Analytics",
  "User testing",
  "Marketing preparation",
  "Influencer launch",
  "Schools outreach",
  "Investor readiness",
  "Launch campaign",
  "Finance and funding",
  "Other",
].map((c) => ({ value: c, label: c }));

export const KANBAN_COLUMNS = ["Not started", "Planned", "In progress", "Blocked", "Ready for review", "Complete"];

export const launchBadge = (status) =>
  ({
    Complete: "success",
    "Ready for review": "info",
    Planned: "info",
    "In progress": "warning",
    Blocked: "error",
    "Not started": "neutral",
  }[status] || "neutral");

export const priorityBadge = (p) =>
  ({ Low: "info", Medium: "info", High: "warning", Critical: "error" }[p] || "neutral");

export const isOverdue = (m, today) =>
  !!m.due_date && m.due_date < today && m.status !== "Complete";

export const launchStatusToSlug = (v) => v.toLowerCase().replace(/\s+/g, "-");
export const launchStatusFromSlug = (slug) => {
  if (!slug) return null;
  const f = LAUNCH_STATUS.find((s) => launchStatusToSlug(s.value) === slug.toLowerCase());
  return f ? f.value : null;
};

// Expedition-journey state of a milestone (drives node colour + label)
export const milestoneState = (m, today) => {
  if (m.status === "Complete") return "complete";
  if (m.status === "Blocked") return "blocked";
  if (m.due_date && today && m.due_date < today) return "overdue";
  if (m.status === "In progress" || m.status === "Ready for review") return "active";
  return "future";
};

export const STATE_META = {
  complete: { color: "#16A34A", label: "Completed" },
  active: { color: "#E0A82E", label: "Active" },
  blocked: { color: "#FB6F5A", label: "Blocked" },
  overdue: { color: "#DC2626", label: "Overdue" },
  future: { color: "#06B6D4", label: "Upcoming" },
};
